import { Link } from 'react-router-dom';
import { firmInfo } from '@/mocks/firm';

export default function ContactCta() {
  return (
    <section className="px-4 md:px-10 py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto bg-background-50 border border-background-200 rounded-lg overflow-hidden flex flex-col lg:flex-row">
        <div className="flex-1 p-8 md:p-12">
          <p className="text-secondary-500 text-xs uppercase tracking-[0.25em] mb-3 font-semibold">Iniciemos una conversación</p>
          <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight">Cómo ubicarnos</h2>
          <p className="text-sm text-foreground-600 mt-4 leading-relaxed max-w-lg">Puede comentarle al Máster qué está pasando. Él personalmente le responderá dentro del espacio de 3 días hábiles.</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8 text-sm">
            <a href={`tel:${firmInfo.phone}`} className="flex items-center gap-3 cursor-pointer"><span className="w-10 h-10 rounded-full bg-secondary-100 text-secondary-600 flex items-center justify-center"><i className="ri-phone-line"></i></span>{firmInfo.phone}</a>
            <a href={`mailto:${firmInfo.email}`} className="flex items-center gap-3 cursor-pointer"><span className="w-10 h-10 rounded-full bg-secondary-100 text-secondary-600 flex items-center justify-center"><i className="ri-mail-line"></i></span>{firmInfo.email}</a>
          </div>
          <Link to="/about#contacto" className="inline-flex items-center gap-2 mt-7 text-sm font-semibold text-primary-500 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap">
            Ver todos los datos de contacto <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="w-full lg:w-[440px] h-[320px] lg:h-auto">
          <iframe
            title="Ubicación del Bufete Ramos Santos en Heredia, Costa Rica"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.2169774244444!2d-84.12309934438427!3d9.998927964674571!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8fa0fb9289fcd6b3%3A0xff4fd86c3afdd6b1!2sBufete%20Ramos%20Santos!5e0!3m2!1ses!2sus!4v1791852247450!5m2!1ses!2sus"
            className="w-full h-full border-0"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
          ></iframe>
        </div>
      </div>
    </section>
  );
}